import { useState } from 'react';
import { useAuth } from '../AuthContext.jsx';

function formatDate(iso) {
  if (!iso) return '';
  const d = typeof iso === 'string' ? new Date(iso + 'T12:00:00Z') : new Date(iso);
  return d.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });
}

const CHECK_LABELS = [
  ['primary_keyword_in_title',            'Primary keyword in title'],
  ['primary_keyword_in_h1',               'Primary keyword in H1'],
  ['primary_keyword_in_first_100',        'Primary keyword in first 100 words'],
  ['primary_keyword_in_slug',             'Primary keyword in slug'],
  ['primary_keyword_in_meta_description', 'Primary keyword in meta description'],
  ['no_em_dashes',                        'No em dashes'],
  ['image_alt_present',                   'Image alt text present'],
];

export default function WhyThisPost({
  clientSummary, primaryKeyword, moneyPage, publishDate, whyNow, selfCheck, tags,
  defaultOpen = false,
}) {
  const { isAgency } = useAuth();
  const [showQuality, setShowQuality] = useState(defaultOpen);
  const needsInput = Array.isArray(selfCheck?.needs_input) ? selfCheck.needs_input : [];
  if (!clientSummary && !primaryKeyword && !moneyPage && !publishDate) return null;

  return (
    <section className="why-card" aria-label="Why this post">
      <h2>Why this post</h2>
      {clientSummary && <p className="summary">{clientSummary}</p>}
      <div className="meta">
        {primaryKeyword && <span><strong>Search we're targeting:</strong> {primaryKeyword}</span>}
        {moneyPage      && <span><strong>Supports your page:</strong> {moneyPage}</span>}
        {publishDate    && <span><strong>Publish date:</strong> {formatDate(publishDate)}</span>}
      </div>
      {Array.isArray(tags) && tags.length > 0 && (
        <div className="tag-chips" aria-label="Tags">
          <strong>Tags:</strong>
          {tags.map((t) => <span key={t} className="tag-chip">{t}</span>)}
        </div>
      )}
      {isAgency && (selfCheck || whyNow) && (
        <>
          <button
            type="button"
            className="quality-toggle"
            onClick={() => setShowQuality((v) => !v)}
            aria-expanded={showQuality}
          >
            {showQuality ? '− Hide quality check' : '+ Show quality check'}
          </button>
          {showQuality && (
            <div className="quality-body">
              {selfCheck?.agency_answered && (
                <p className="needs-note">
                  This post was drafted without a client questions round. The lines below are what
                  the client would normally have supplied. Fill them in, or ask the client, before you send it.
                </p>
              )}
              {needsInput.length > 0 && (
                <div className="needs-input" aria-label="Needs filling in">
                  <div className="needs-title">Needs filling in ({needsInput.length})</div>
                  <ol>
                    {needsInput.map((line, i) => <li key={i}>{line}</li>)}
                  </ol>
                </div>
              )}
              {selfCheck && (
                <ul>
                  {CHECK_LABELS.map(([key, label]) => {
                    const v = selfCheck[key];
                    if (v === null || v === undefined) return null;
                    const pass = !!v;
                    return (
                      <li key={key} className={pass ? 'pass' : 'warn'}>
                        <span className="mark">{pass ? '✓' : '!'}</span>
                        <span>{label}</span>
                      </li>
                    );
                  })}
                  {typeof selfCheck.word_count === 'number' && (
                    <li className="pass">
                      <span className="mark">·</span>
                      <span>Word count: {selfCheck.word_count}</span>
                    </li>
                  )}
                  {selfCheck.internal_links && (
                    <li className={selfCheck.internal_links.money_page_linked ? 'pass' : 'warn'}>
                      <span className="mark">{selfCheck.internal_links.money_page_linked ? '✓' : '!'}</span>
                      <span>
                        Money page linked
                        {' · '}
                        {selfCheck.internal_links.count || 0} internal link
                        {selfCheck.internal_links.count === 1 ? '' : 's'}
                      </span>
                    </li>
                  )}
                  {selfCheck.warnings?.length > 0 && selfCheck.warnings.map((w, i) => (
                    <li key={`w${i}`} className="warn">
                      <span className="mark">!</span>
                      <span>{w}</span>
                    </li>
                  ))}
                </ul>
              )}
              {whyNow && <p className="why-now">Why now: {whyNow}</p>}
            </div>
          )}
        </>
      )}
    </section>
  );
}
